import React from "react";
import PropTypes from "prop-types";
import { Select, Form, Row } from "antd";

const { Option } = Select;

const rowStyles = { marginBottom: 8 };

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 12 },
    lg: { span: 10 },
  },
  style: { marginBottom: 0 },
};

function HmgMainDropdown(props) {
  const hmgmainStyles = props.hmgmainStyles
    ? props.hmgmainStyles
    : formItemLayout;
  return (
    <Form.Item {...hmgmainStyles} label="Hotel Management Group">
      <Row style={rowStyles}>
        <Select
          showSearch
          placeholder="Please Select Hotel Management Group"
          value={props.hmgmainSelect}
          style={{ width: "100%", maxWidth: "450px" }}
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          onChange={props.hmgmainChange}
        >
          {props.hmgmainList.map((el) => (
            <Option key={el._id}>{el.hmg_name}</Option>
          ))}
        </Select>
      </Row>
    </Form.Item>
  );
}

// HmgMainDropdown.propTypes = {

// }

export default HmgMainDropdown;
